import {
    SET_LOADING
} from "../actionTypes";

const INITIAL_STATE = {
    isLoading: false,
    mensagemLoading: ""
};

// eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                isLoading: action.payload.loading,
                mensagemLoading: action.payload.mensagem
            };        
        default:
            return state;
    }
};
